'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./dialog.scss');

var _dialogWrapper = require('./dialog-wrapper');

var _dialogWrapper2 = _interopRequireDefault(_dialogWrapper);

var _icon = require('../icon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _toolbar = require('../toolbar/toolbar');

var _toolbar2 = _interopRequireDefault(_toolbar);

var _title = require('../title/title');

var _title2 = _interopRequireDefault(_title);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Dialog = _react2.default.forwardRef(function (_ref, ref) {
  var align = _ref.align,
      children = _ref.children,
      className = _ref.className,
      density = _ref.density,
      icon = _ref.icon,
      footer = _ref.footer,
      size = _ref.size,
      state = _ref.state,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ['align', 'children', 'className', 'density', 'icon', 'footer', 'size', 'state', 'title']);

  var classes = (0, _classnames2.default)('dialog', 'dialog--align-' + align, 'dialog--size-' + size, density && 'dialog--density-' + density, state && 'dialog--state-' + state, className);

  var hasHeader = icon || title;

  var headerClasses = (0, _classnames2.default)('dialog__header', !title && 'dialog__header--striped-title', !icon && 'dialog__header--striped-icon');

  var contentClasses = (0, _classnames2.default)('dialog__content', !hasHeader && 'dialog__content--no-header');

  // TODO: REMOVE hide-on-mobile, hide-on-desktop

  return _react2.default.createElement(
    _dialogWrapper2.default,
    _extends({ ref: ref, className: classes }, props),
    hasHeader && _react2.default.createElement(
      'div',
      { className: headerClasses },
      icon && _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'dialog__icon hide-on-mobile' },
          _react2.default.createElement(_icon2.default, { name: icon, size: '30' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'dialog__icon hide-on-desktop' },
          _react2.default.createElement(_icon2.default, { name: icon, size: '20' })
        )
      ),
      title && _react2.default.createElement(
        _title2.default,
        {
          level: '3',
          weight: 'regular',
          color: 'darkest',
          density: 'airy',
          className: 'dialog__title',
          align: align
        },
        title
      )
    ),
    _react2.default.createElement(
      'div',
      { className: contentClasses },
      children
    ),
    footer && _react2.default.createElement(
      _toolbar2.default,
      {
        density: 'comfortable',
        className: 'dialog__toolbar',
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      },
      footer
    )
  );
});

Dialog.propTypes = {
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  density: _propTypes2.default.oneOf(['none', 'medium']),
  icon: _propTypes2.default.string,
  footer: _propTypes2.default.element,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large']),
  state: _propTypes2.default.oneOf(['active', 'inactive', 'warning', 'info']),
  title: _propTypes2.default.string,
  renderCustomHeader: _propTypes2.default.func
};

Dialog.defaultProps = {
  align: 'center',
  density: 'medium',
  size: 'medium',
  renderCustomHeader: function renderCustomHeader() {
    return null;
  }
};

exports.default = Dialog;